module.exports = __webpack_public_path__ + "static/media/rec_New.b493de1c.svg";